<h2>Términos y Condiciones</h2>

<div class="terminos-container">
  <p class="mensaje-informativo" *ngIf="esPrimeraVez">
    Por favor lee y acepta los Términos y Condiciones para continuar.
  </p>
  <p class="mensaje-informativo" *ngIf="!esPrimeraVez">
    Los Términos y Condiciones han sido actualizados. Por favor, lee y aceptalos
    nuevamente.
  </p>

  <div class="link-terminos-container">
    <a
      class="link-terminos"
      (click)="onLinkClick()"
      [href]="url"
      target="_blank"
    >
      Leer Términos y Condiciones
    </a>
    <mat-error *ngIf="!aceptado || !textoLeido" >
      Por favor abre y acepta los términos y condiciones para continuar.
    </mat-error>
  </div>

  <mat-checkbox [(ngModel)]="aceptado" color="primary">
    Acepto los Términos y Condiciones
  </mat-checkbox>
</div>

<div class="acciones">
  <button
    mat-raised-button
    color="warn"
    (click)="rechazar()"
    [disabled]="aceptado"
  >
    Rechazar
  </button>
  <button
    mat-raised-button
    color="primary"
    [disabled]="!aceptado || !textoLeido"
    (click)="aceptar()"
  >
    Aceptar
  </button>
</div>
